<template>
    <div class="HomeAboutPopVideo" v-if="isActive" :class="isShow && `show`">

        <div class="HomeAboutPopVideo-before"></div>
        <div class="HomeAboutPopVideo-content">
            <button type="button" class="HomeAboutPopVideo-close" @click="close">
                <span class="material-symbols-outlined">close</span>
            </button>

            <div class="stage">
                <iframe v-if="iframeUrl" class="iframe" :src="iframeUrl" frameborder="0" allowfullscreen="true"
                    webkitallowfullscreen="true" allow="autoplay;encrypted-media"></iframe>
                <video class="HomeAboutPopVideo-video" v-else-if="videoUrl" autoplay controls :poster="imageUrl">
                    <source :src="videoUrl" type="video/mp4">
                </video>

            </div>
        </div>

        <div class="HomeAboutPopVideo-affter"></div>
    </div>
</template>

<script>
export default {

    computed: {
        active() {
            return this.$store.getters.homeAboutPopVideo
        },
    },

    watch: {
        active(response) {

            if (response) {

                if (typeof response === Object) {
                    if (response.iframeUrl) {
                        this.iframeUrl = response.iframeUrl
                    }
                    else if (response.videoUrl) {
                        this.videoUrl = response.videoUrl
                    }
                }
                else {
                    this.videoUrl = response
                }

                this.isActive = true


                setTimeout(() => {
                    this.isShow = true
                }, 100);

            }
            else {
                this.isShow = false
                this.isActive = false

                this.videoUrl = null
                this.iframeUrl = null
            }
        }
    },

    data() {
        return {
            isActive: false,
            isShow: false,

            imageUrl: null,
            videoUrl: null,
            iframeUrl: null, // https://play.google.com/video/lava/web/player/yt:movie:vhypCuj1w5s.P?autoplay=1&amp;authuser=0&amp;embed=play
        }
    },
    methods: {
        close() {
            // this.isActive = false
            this.$store.dispatch('setHomeAboutPopVideo', false)
        },

        
    }
}
</script>

<style lang="scss" scoped>
.HomeAboutPopVideo {
    position: fixed;
    inset: 0;

    z-index: 800;

    display: flex;
    align-items: center;
    // justify-content: center;
    flex-direction: column;
    z-index: 1200;
    inset: 0px;

    opacity: 0;

    padding: 0 5%;

    transition: opacity .15s cubic-bezier(0.4, 0, 0.2, 1) .15s;
    background-color: rgba(0, 0, 0, .75);

    &.show {
        transition: opacity .05s cubic-bezier(0.4, 0, 0.2, 1);
        opacity: 1;
    }
}

.HomeAboutPopVideo-before {
    flex-grow: 1;
    display: block;
    height: 3em;
}

.HomeAboutPopVideo-affter {
    flex-grow: 1;
    display: block;
    height: 3em;
}

.HomeAboutPopVideo-content {
    flex-shrink: 1;
    max-height: 100%;

    box-sizing: border-box;
    position: relative;
    box-shadow: rgb(20 21 26 / 16%) 0px 8px 16px, rgb(71 77 87 / 16%) 0px 16px 32px, rgb(20 21 26 / 10%) 0px 0px 1px;
    background-color: rgb(255, 255, 255);

    // height: 300px;
    width: 100%;
    max-width: 853px;
}

.stage {
    display: flex;
    flex-direction: column;
}

.HomeAboutPopVideo-video {
    width: 100%;
}

.HomeAboutPopVideo-close {
    position: absolute;
    left: 100%;
    top: 0;

    width: 40px;
    height: 40px;
    background-color: #f2f2f2;

    display: flex;
    justify-content: center;
    align-items: center;

    border-width: 0;
}

.iframe {
    background-color: black;
    // height: 100%;
    // left: 0;
    // position: absolute;
    // top: 0;
    width: 100%;
}

@media screen and (min-width: 840px) {
    .iframe {
        display: block;
        height: 480px;
        position: relative;
        width: 853px;
    }
}
</style>